import { Link } from "@tanstack/react-router";
import { FaEdit } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { LiaTimesSolid } from "react-icons/lia";

import { titleCase } from "../../utils";
import Card from "./card";

export const UserCard = ({ user }: { user: any }) => {
  const getIconForAttribute = (attr: string) => {
    const IconComponent = user[attr] ? FaCheck : LiaTimesSolid;
    return (
      <IconComponent
        title={`${titleCase(attr)}: ${JSON.stringify(!!user[attr])}`}
        className="align-middle text-lg"
      />
    );
  };

  return (
    <Card className="my-4 flex flex-row">
      <div className="flex flex-grow flex-col">
        <h2 className="mb-4 text-xl text-blue-200">{user.email}</h2>
      </div>

      <div className="flex flex-row gap-4">
        {/* Flags */}
        <div className="flex flex-col items-center">
          <h2 className="mb-2 text-xl text-blue-200">Active</h2>
          {getIconForAttribute("is_active")}
        </div>
        <div className="flex flex-col items-center">
          <h2 className="mb-2 text-xl text-blue-200">Verified</h2>
          {getIconForAttribute("is_verified")}
        </div>
        <div className="flex flex-col items-center">
          <h2 className="mb-2 text-xl text-blue-200">Superuser</h2>
          {getIconForAttribute("is_superuser")}
        </div>
      </div>

      <div className="flex flex-col pl-5">
        <div className="grow" />
        <Link to={`/user/${user.id}` as any}>
          <button className="ox-button w-26 mt-2 px-2 py-1">
            <FaEdit className="mr-4 align-middle" />
            Update User Detail
          </button>
        </Link>
      </div>
    </Card>
  );
};
